import { createProfessionalExporter } from '../../utils/professionalExport';

const headers = ['Name', 'Start Date', 'End Date', 'Description'];

const exporter = createProfessionalExporter({
  title: 'Class List',
  headers,
  slug: 'classes',
  getRows: (list) =>
    list.map((c) => [c.name, c.startDate, c.endDate, c.description || '']),
  getSummary: (list) => [`Total classes: ${list.length}`],
});

export const printClassList = (data) => exporter.print(data);
export const exportClassCsv = (data) => exporter.csv(data);
export const exportClassExcel = (data) => exporter.excel(data);
export const exportClassPdf = (data) => exporter.pdf(data);
export const exportClasses = (data) => exporter.export(data);
